module.exports = __webpack_public_path__ + "static/media/sdc-logo.e1bc7fa9.png";